import { Container } from '../EquipmentBar.styles';

const EquipmentBarError = () => {
  return <Container>Error on load equipment</Container>;
};

export { EquipmentBarError };
